<template>
  <div class="current-rides container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div style="display: flex; flex-direction: column;">

      <div class="row page-titles">
        <div class="col-md-5 align-self-center">
          <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
            <li class="breadcrumb-item active">{{ title }}</li>
          </ol>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="report-container">
                <div class="" style="">
                  <form v-on:submit.prevent>
                    <table class="table table-sm table-hover" data-sort-name="Date">
                      <thead>
                      <tr>
                        <th class="result-label">
                          <select class="form-control table-select" @change="checkSelection($event)" onfocus="this.selectedIndex = 0">
                            <option selected="selected">
                              Select
                            </option>
                            <option>
                              All
                            </option>
                            <option>
                              None
                            </option>
                          </select>
                        </th>
                        <th class="result-label" style="min-width: 100px;" v-for="column in data.resultColumns">
                          <div>
                            {{column}}
                            <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                          </div>
                        </th>
                      </tr>
                      </thead>
                      <tbody class="col-12">
                      <tr class="ride-item text-xs-center" v-for="transaction in data.adjustments" >
                        <!--<td class="result-item" v-for="item in transaction">-->
                        <!--{{ item }}-->
                        <!--</td>-->
                        <!-- Checkbox -->
                        <td class="result-item text-center" width="80px">
                          <input type='checkbox' v-bind:value='transaction' v-model='data.pool' v-bind:id="transaction.id_transaction">
                          <label class="search-label" v-bind:for="transaction.id_transaction" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                        </td>
                        <td class="result-item">
                          <router-link :to="'/rides/' + transaction.id_ride.id_ride + '/'">
                            <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                            {{ transaction.id_ride.id_ride }}
                          </router-link>
                        </td>
                        <td class="result-item">
                          <router-link :to="'/rides/' + transaction.id_ride.id_ride + '/'">
                            <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                            {{ transaction.id_ride.id_alternate ? transaction.id_ride.id_alternate : 'N/A' }}
                          </router-link>
                        </td>
                        <td>
                          {{ transaction.id_ride.id_market.name }}
                        </td>
                        <td>
                          {{ transaction.id_ride.deadhead && transaction.id_ride.deadhead == 1 ? 'Deadhead' : 'Regular' }}
                        </td>
                        <td>
                          {{ transaction.id_ride.id_type_ride_status.name }}
                        </td>
                        <td>
                          {{ transaction.id_ride.claim.name ? transaction.id_ride.claim.name : "N/A" }}
                        </td>
                        <td class="result-item">
                          <router-link :to="'/drivers/' + transaction.to_id_user.id_user + '/'">
                            {{ transaction.to_id_user && transaction.to_id_user.id_user ? (transaction.to_id_user.name_first + ' ' + transaction.to_id_user.name_last) : 'N/A' }}
                          </router-link>
                        </td>
                        <td>
                          {{ transaction.id_ride.date_pickup_local ? moment.utc(transaction.id_ride.date_pickup_local).tz(transaction.id_ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(transaction.id_ride.date_pickup).tz(transaction.id_ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') }}
                        </td>
                        <td>
                          {{ transaction.amount }}
                        </td>
                        <td>
                          {{ transaction.comment }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>
                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row assign-ride-actions" style="margin: 25px 0;">
        <div class="submit-button">
          <button v-on:click="data.showMessageModal = true" class="btn btn-info waves-effect waves-light m-t-10" >Approve</button>
        </div>
        <div class="submit-button">
          <button id="assign" v-on:click="validateAdjustments('deny')" class="btn btn-info waves-effect waves-light m-t-10" >Deny</button>
        </div>
      </div>

    </div>

    <!-- Send-back confirmation popup alert -->
    <div id="sendBackConfirmation">
      <div v-if="this.data.pool.length > 0">
        <modal v-if="data.showMessageModal" @close="data.showMessageModal = false">
          <h3 slot="header">Confirm Transaction Approval</h3>
          <h5 slot="body">Please include a message to be displayed for this transaction on the driver's wallet:</h5>
          <div slot="footer" style="width: 100%;">
            <input v-model="currentMessage" class="form-control form-control-sm" placeholder="Message" style="width:100%" type="text">
            <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showMessageModal = false;">
              Back
            </button>
            <button id="cancelTrue" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showMessageModal = false; validateAdjustments('approve');">
              Approve
            </button>
          </div>
        </modal>
      </div>
      <div v-else>
        <modal v-if="data.showMessageModal" @close="data.showMessageModal = false">
          <h3 slot="header">Cancel Ride</h3>
          <h5 slot="body">Please select at least one transaction</h5>
          <div slot="footer" >
            <button style="width: 60px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showMessageModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Payment Adjustments',
    },
    name: "PaymentAdjustments",
    data () {
      return {
        title: 'Payment Adjustments',
        currentMessage: null,
        totalRows: 0,
        data: {
          markets: null,
          adjustments: [],
          resultColumns: ["Ride ID", "Leg ID", "Market", "Ride Type", "Ride Status", "Claims Status", "Driver", "Pick-up Date", "Adjustment Amount", "Comment"],
          sortDirection: 0,
          pool: [],
          showMessageModal: false,
        },
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 20,
        errors: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      getAdjustments: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'transactions/?type=adjustments&ordering=-id_ride'
            + '&page=' + (page ? page : this.currentPage))
          .then(response => {
            this.totalRows = response.data.count
            this.data.adjustments = response.data.results
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      validateAdjustments: function (type) {
        const getRides = (currentValue) => currentValue.id_ride;
        var ids = []
        this.data.pool.forEach(function (item, index) {
          ids.push(item['id_transaction'])
        });
        var params = {
          "message": this.currentMessage,
          "ids": ids
        }
        if (type === "approve" && this.currentMessage === null) {
          Vue.toasted.show('Please include a message', {
            theme: 'bubble',
            position: 'top-right',
            duration: 2000
          })
          this.data.showMessageModal = true
        }
        else {
          this.isLoading = true
          this.$http
            .post(process.env.API_BASE_URL_CS + 'transactions/validate-adjustment/?type=' + type, params)
            .then(response => {
              this.totalRows = response.data.count
              this.data.adjustments = response.data.results
            })
            .catch(error => {
              this.check403(error);
              if (error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              console.log(error)
              this.errored = true
            })
            .finally(() => {
              this.isLoading = false
              this.data.pool = []
              this.currentMessage = null
              this.getAdjustments()
            })
        }
      },
      checkSelection: function(event) {
        this.data.isCheckAll = event.srcElement.selectedIndex == 1 ? false : true
        this.checkAll()
      },
      checkAll: function() {
        this.data.isCheckAll = !this.data.isCheckAll
        this.data.pool = []
        if(this.data.isCheckAll){ // Check all
          for (var key in this.data.adjustments) {
            this.data.pool.push(this.data.adjustments[key])
          }
        }
      },
      checkPageSize: function(event) {
        this.getAdjustments()
      },
      changePage: function (page) {
        this.getAdjustments(page)
      },
    },
    mounted () {
      this.getAdjustments()
    },
    created () {
      // document.title = "Wingz Support | Current Rides";
    }
  }
</script>

<style scoped>
  .assign-ride-actions {
    display: block;
    text-align: right;
  }
  .assign-ride-actions .submit-button {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/PaymentAdjustments.vue